const carouselItems = [
  {
    id: 1,
    title: '古装仙侠剧场',
    subtitle: '玄幻修真 · 仙侠奇缘',
    description: '沉浸东方美学世界，感受仙侠世界的爱恨情仇与磅礴气势',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20ancient%20fantasy%20landscape%20with%20floating%20mountains%20and%20golden%20clouds%2C%20traditional%20Chinese%20architecture%20with%20flowing%20silk%20ribbons%2C%20mystical%20atmosphere%20with%20soft%20warm%20lighting%2C%20elegant%20ink%20wash%20painting%20style%2C%20cinematic%20composition%2C%20dreamy%20and%20romantic%20mood&width=600&height=400&seq=carousel-01-xianxia&orientation=landscape',
    badge: '热门专题',
  },
  {
    id: 2,
    title: '都市情感剧场',
    subtitle: '现实题材 · 情感共鸣',
    description: '演绎当代都市生活百态，真实温暖触动每一颗追剧的心',
    image: 'https://readdy.ai/api/search-image?query=Warm%20modern%20city%20nightscape%20with%20soft%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20cozy%20apartment%20interior%20with%20warm%20lamp%20glow%2C%20cinematic%20urban%20romance%20atmosphere%2C%20emotional%20storytelling%20mood%2C%20soft%20focus%20background%2C%20contemporary%20Chinese%20city%20life%20aesthetic&width=600&height=400&seq=carousel-02-urban&orientation=landscape',
    badge: '人气精选',
  },
  {
    id: 3,
    title: '悬疑推理剧场',
    subtitle: '烧脑剧情 · 层层反转',
    description: '挑战推理极限，每一集都让你猜不到结局的精彩谜题',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20noir%20style%20scene%20with%20dramatic%20shadows%20and%20contrast%2C%20detective%20office%20with%20vintage%20desk%20lamp%20casting%20long%20shadows%2C%20dark%20alleyway%20with%20fog%20and%20warm%20streetlight%2C%20suspenseful%20cinematic%20atmosphere%2C%20rich%20textured%20surfaces%2C%20moody%20and%20intriguing%20composition&width=600&height=400&seq=carousel-03-suspense&orientation=landscape',
    badge: '烧脑推荐',
  },
  {
    id: 4,
    title: '年代传奇剧场',
    subtitle: '家国情怀 · 时代印记',
    description: '重温激荡岁月中的传奇故事，感受大时代下的人物命运',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20Shanghai%20street%20scene%20from%201930s%20with%20classic%20architecture%20and%20warm%20sepia%20tones%2C%20old%20photographs%20scattered%20on%20wooden%20table%20with%20soft%20sunlight%2C%20nostalgic%20and%20elegant%20atmosphere%2C%20historical%20drama%20aesthetic%2C%20rich%20warm%20brown%20and%20gold%20color%20palette&width=600&height=400&seq=carousel-04-period&orientation=landscape',
    badge: '经典回顾',
  },
  {
    id: 5,
    title: '青春校园剧场',
    subtitle: '纯真年代 · 成长故事',
    description: '回到最美好的青春时光，那些关于梦想与友情的故事',
    image: 'https://readdy.ai/api/search-image?query=Bright%20sunlit%20school%20campus%20with%20cherry%20blossom%20trees%20in%20spring%2C%20empty%20classroom%20with%20warm%20afternoon%20light%20streaming%20through%20windows%2C%20youthful%20and%20nostalgic%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20cinematic%20coming%20of%20age%20mood%2C%20gentle%20and%20dreamy%20composition&width=600&height=400&seq=carousel-05-youth&orientation=landscape',
    badge: '青春记忆',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            精选专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精心策划五大主题剧场，按你的喜好找到最合适的电视剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-300/50"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/85 text-white">
                  {item.badge}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselItems.slice(3).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col sm:flex-row bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-300/50"
            >
              <div className="relative sm:w-56 h-48 sm:h-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).parentElement!.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500/85 text-white">
                  {item.badge}
                </span>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}